export const ALISOF_MODULE_NAME = "alisof_module";

export const alisofModuleMenuItem = {
  icon: "language",
  path: "/alisof/translations",
};

export const alisofPosicionesMenuItem = {
  icon: "table",
  path: "/posiciones",
};

export const alisofModuleRoutes = [
  {
    path: "posiciones",
    name: "AlisofPosiciones",
    component: () => import("./pages/AlisofPosiciones.vue"),
    meta: {
      title: "Posiciones",
      requiresAuth: true,
      requiresModule: ALISOF_MODULE_NAME,
    },
  },
  {
    path: "alisof/translations",
    name: "AlisofTranslations",
    component: () => import("./pages/AlisofTranslations.vue"),
    meta: {
      title: "Traducciones Alisof",
      requiresAuth: true,
      requiresModule: ALISOF_MODULE_NAME,
    },
  },
];

export default {
  moduleName: ALISOF_MODULE_NAME,
  routes: alisofModuleRoutes,
  menuItem: alisofModuleMenuItem,
};
